module.exports = __webpack_public_path__ + "static/r-and-d-f9d637a8623c63ec2a44c463c5702013.svg";